/**
 * get all parameter and push them into an array
 *
 * @params key (if key is a single url-param -> return paramValue // if key is set to true -> return all params);
 * @returns {Array}
 */

getUrlParams = function (key) {

  /**
   * get all parameter and push them into an array
   *
   * @params key (if key is a single url-param -> return paramValue // if key is set to true -> return all params);
   * @returns {Array}
   */
  function get_GET_params(getAll) {
    var GET = [];

    if(location.search.length > 0) {
      var get_param_str = location.search.substring(1, location.search.length),
          get_params = get_param_str.split("&"),
          i = 0,
          key_value = '';

      if(getAll === true){
        for(i = 0; i < get_params.length; i++) {
          key_value = get_params[i].split("=")[0];
          GET.push(key_value);
        }
      }

      else {
        for(i = 0; i < get_params.length; i++) {
          key_value = get_params[i].split("=");
          if(key_value.length == 2) {
            var key = key_value[0],
                value = key_value[1];
            GET[key] = value;
          }
        }
      }
    }
    return(GET);
  }

  var get_params = get_GET_params();

  if(key === true){
    return get_GET_params(true);
  }
  else if(get_params[key])
    return(get_params[key]);
  else
    return false;
}


scrollToIDHash = function ($obj) {
  if (getUrlParams('show')) {
    var tabItem = getUrlParams('show');

    setTimeout(function() {
      $('html, body, .scroll-container').stop().animate({
        scrollTop: ($('#'+ tabItem +'').offset().top - 65)
      }, 800);

    }, 1000);
  }
};

scrollToIDHash();

